/* eslint-disable @typescript-eslint/no-explicit-any */
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export type BenefitBreakdownType = {
  tier: string; // "TIER_1", "TIER_2", etc.
  billingClass: string; // "PROFESSIONAL" | "FACILITY"
  condition: string; // "DED_WAIVED" | "N/A"
  code: string; // e.g., "4", "5", "1" (service code)
  codeDescription: string; // e.g., "OFFICE", "INPATIENT"
  copay: string; // copay amount or code ("20", "N/A", "CE001", etc.)
  coinsurance: string; // coinsurance amount ("0", etc.)
  serviceLimit: string; // "N/A" or other limits
  categoryCode: string; // e.g., "SC1"
};

function flatternBenefitBreakdown(json: any) {
  const flatList: BenefitBreakdownType[] = [];

  json.results.forEach((result: any) => {
    const categoryCode = result.categoryCode;
    result.data.forEach((tierData: any) => {
      const tier = tierData.tier;
      tierData.placeOfService.forEach((pos: any) => {
        const billingClass = pos.billingClass;
        pos.services.forEach((service: any) => {
          flatList.push({
            tier,
            billingClass,
            condition: service.condition,
            code: service.code,
            codeDescription: service.codeDescription,
            copay: service.copay,
            coinsurance: service.coinsurance,
            serviceLimit: service.serviceLimit,
            categoryCode,
          });
        });
      });
    });
  });

  return flatList;
}
const initialState = {
  breakdown: [] as BenefitBreakdownType[],
};

const benefitBreakdownSlice = createSlice({
  name: "benefitBreakdown",
  initialState,
  reducers: {
    setFlatBenefitBreakdown(state: any, action: PayloadAction<any>) {
      // console.log(
      //   "@debug action.payload = ",
      //   flatternBenefitBreakdown(action.payload),
      // );
      state.breakdown = flatternBenefitBreakdown(action.payload);
    },
  },
});

export const { setFlatBenefitBreakdown } = benefitBreakdownSlice.actions;

export default benefitBreakdownSlice.reducer;
